import React, { Component } from "react";
import {
  FormGroup,
  Row,
  Col,
  Alert,
  FormControl,
  Form,
} from "react-bootstrap";
import "react-day-picker/lib/style.css";
import { msgs } from "src/js/ErrorMessage.js";
import "src/css/SafetyMap.css";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class EventPeriodForm extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      selectFrom: {
        value: this.props.eventPeriodForm,
      },
      selectTo: {
        value: this.props.eventPeriodTo,
      },
    };
    this.handleFromSelect = this.handleFromSelect.bind(this);
    this.handleToSelect = this.handleToSelect.bind(this);
  }

  validate(from, to) {
    // 日付前後整合判定
    if (from > to) {
      this.setState({
        isError: true,
        errorMsg: msgs["msg_validate_01"],
      });
      return false;
    }

    // バリデートに問題なければエラー関連Stateをリセット
    this.setState({
      isError: false,
      errorMsg: "",
    });

    return true;
  }

  handleFromSelect() {
    const from = Number(this.selectFrom.value); 
    const to = Number(this.selectTo.value);
    if (!this.validate(from, to)) {
      return;
    }
    this.props.selectPeriodFrom(from);
  }

  handleToSelect() {
    const from = Number(this.selectFrom.value); 
    const to = Number(this.selectTo.value);
    if (!this.validate(from, to)) {
      return;
    }
    this.props.selectPeriodTo(to);
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <span>
        {this.state.isError ? (
          <Alert bsStyle="danger">{t("Message." + this.state.errorMsg)}</Alert>
        ) : (
          false
        )}
      </span>
    );

    return (
      <div className="selectPeriod">
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Error />
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Form horizontal>
              <Col md={5} sm={5} xs={5} id="from" className="timePicker">
                <FormGroup >
                  <FormControl
                    componentClass="select"
                    defaultValue={this.props.eventPeriodFrom}
                    onChange={this.handleFromSelect.bind(this)}
                    inputRef={(ref) => {
                      this.selectFrom = ref;
                    }}
                  >
                    <option value="0">0:00</option>
                    <option value="1">1:00</option>
                    <option value="2">2:00</option>
                    <option value="3">3:00</option>
                    <option value="4">4:00</option>
                    <option value="5">5:00</option>
                    <option value="6">6:00</option>
                    <option value="7">7:00</option>
                    <option value="8">8:00</option>
                    <option value="9">9:00</option>
                    <option value="10">10:00</option>
                    <option value="11">11:00</option>
                    <option value="12">12:00</option>
                    <option value="13">13:00</option>
                    <option value="14">14:00</option>
                    <option value="15">15:00</option>
                    <option value="16">16:00</option>
                    <option value="17">17:00</option>
                    <option value="18">18:00</option>
                    <option value="19">19:00</option>
                    <option value="20">20:00</option>
                    <option value="21">21:00</option>
                    <option value="22">22:00</option>
                    <option value="23">23:00</option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={2} sm={2} xs={2} className="timePicker">
                ~
              </Col>
              <Col md={5} sm={5} xs={5} id="to" className="timePicker">
                <FormGroup>
                  <FormControl
                    componentClass="select"
                    defaultValue={this.props.eventPeriodTo}
                    onChange={this.handleToSelect.bind(this)}
                    inputRef={(ref) => {
                      this.selectTo = ref;
                    }}
                  >
                    <option value="0">0:00</option>
                    <option value="1">1:00</option>
                    <option value="2">2:00</option>
                    <option value="3">3:00</option>
                    <option value="4">4:00</option>
                    <option value="5">5:00</option>
                    <option value="6">6:00</option>
                    <option value="7">7:00</option>
                    <option value="8">8:00</option>
                    <option value="9">9:00</option>
                    <option value="10">10:00</option>
                    <option value="11">11:00</option>
                    <option value="12">12:00</option>
                    <option value="13">13:00</option>
                    <option value="14">14:00</option>
                    <option value="15">15:00</option>
                    <option value="16">16:00</option>
                    <option value="17">17:00</option>
                    <option value="18">18:00</option>
                    <option value="19">19:00</option>
                    <option value="20">20:00</option>
                    <option value="21">21:00</option>
                    <option value="22">22:00</option>
                    <option value="23">23:00</option>
                  </FormControl>
                </FormGroup>
              </Col>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(EventPeriodForm);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventPeriodForm.js